export const isUserLoggedIn = state => !!state.user.email;
export const getUser = state => state.user;
